/**
 * SharePoint site configuration.
 * Single source of truth for site URL, lists, libraries, and API helpers.
 */

/** SharePoint host (tenant root) */
// export const SP_HOST = 'https://aufaitcloud.sharepoint.com';
export const SP_HOST = 'https://bectors.sharepoint.com';

/** MSAL scope for SharePoint REST API */
export const SP_MSAL_SCOPE = `${SP_HOST}/.default`;

// /** Production SharePoint site URL */
export const SP_SITE_URL = `${SP_HOST}/sites/PTMS_PRD`;
// /** Production server-relative site path */
export const SP_SITE_PATH = '/sites/PTMS_PRD';

// /** UAT SharePoint site URL */
// export const SP_SITE_URL = `${SP_HOST}/sites/PTMS_UAT`;
// /** UAT server-relative site path (used for folder uploads) */
// export const SP_SITE_PATH = '/sites/PTMS_UAT';

/** DEV SharePoint site URL */
// export const SP_SITE_URL = `${SP_HOST}/sites/Mrs_Bectors_PTMS`;
/** DEV server-relative site path (used for folder uploads) */
// export const SP_SITE_PATH = '/sites/Mrs_Bectors_PTMS';

/** SharePoint list titles */
export const SHAREPOINT_LISTS = {
  EMPLOYEE_LIST: 'EmployeeList',
  CRITERIA_MASTER: 'CriteriaMaster',
} as const;

/** SharePoint document library titles */
export const SHAREPOINT_LIBRARIES = {
  BACKING_CODING: 'CodingDocuments',
  BAKING_AND_COOLING: 'BakingandCoolingDocuments',
  CODE_VERIFICATION: 'CodeVerificationDocuments',
  BAKING_PROCESS: 'BakingProcessDocuments',
  MIXING_BAKING: 'MixingBaking_Docs',
  CCP_OPRP_SIEVES: 'CCP_OPRP_Sieves_Docs',
} as const;

export type SharePointLibraryName =
  (typeof SHAREPOINT_LIBRARIES)[keyof typeof SHAREPOINT_LIBRARIES];

/** SharePoint site origin (e.g. https://bectors.sharepoint.com) */
export function getSharePointOrigin(): string {
  return new URL(SP_SITE_URL).origin;
}

/** Build SharePoint REST API URL under the configured site */
export function buildSharePointApiUrl(path: string): string {
  const normalized = path.startsWith('/') ? path.slice(1) : path;
  return `${SP_SITE_URL}/_api/${normalized}`;
}

/** Build server-relative folder path for a document library */
export function buildSharePointLibraryFolderPath(libraryName: string): string {
  return `${SP_SITE_PATH}/${libraryName}`;
}

/** Build SharePoint list items URL with optional OData query string */
export function buildSharePointListItemsUrl(
  listTitle: string,
  query?: string
): string {
  const base = buildSharePointApiUrl(`web/lists/getbytitle('${listTitle}')/items`);
  return query ? `${base}?${query}` : base;
}

/** SharePoint contextinfo endpoint (form digest) */
export function buildSharePointContextInfoUrl(): string {
  return buildSharePointApiUrl('contextinfo');
}

/** Current SharePoint user profile endpoint */
export function buildSharePointCurrentUserUrl(): string {
  return buildSharePointApiUrl('web/currentuser');
}

/** SharePoint site users endpoint */
export function buildSharePointSiteUsersUrl(query: string): string {
  return buildSharePointApiUrl(`web/siteusers?${query}`);
}
